/**
 * P05 flag readers — deliberately NOT in lib/pip/module-flags.ts: that
 * registry's 'VERDICT' name is already taken by InternetVerdict, and the
 * shared file is owned elsewhere. Same semantics, local reader.
 *
 * BUILD-TIME INLINING CAVEAT (same as module-flags.ts): NEXT_PUBLIC_* values
 * are string-replaced at build time only as literal member expressions —
 * keep `process.env.NEXT_PUBLIC_X` spelled out, never a dynamic lookup, and
 * remember a flag change requires a rebuild, not just an env edit.
 */

import { legacyPreviewGate } from '@/lib/pip/module-flags'

/**
 * PDP deal-verdict module. '1' force-on, '0' force-off, unset → the legacy
 * preview gate (visible in dev, hidden in prod).
 */
export function dealVerdictModuleEnabled(): boolean {
  const v = process.env.NEXT_PUBLIC_MODULE_DEAL_VERDICT
  if (v === '1') return true
  if (v === '0') return false
  return legacyPreviewGate()
}

/**
 * Black Friday hub + deals feed + their sitemap entry — all flip together.
 * '1' force-on, '0' force-off, unset → dev only. Production stays a 404
 * until the owner go (P05 ships dark).
 */
export function bfHubEnabled(): boolean {
  const v = process.env.NEXT_PUBLIC_BF_HUB_ENABLED
  if (v === '1') return true
  if (v === '0') return false
  return process.env.NODE_ENV === 'development'
}
